<template>
	<div class="create">
		<!-- 比赛信息 -->
		<p class="title">比赛信息</p>
		<div class="row flex start limit" :data-length="nameLimit">
			<label>名 称：</label>
			<input v-model="params.name" maxlength="20" type="text" placeholder="请输入比赛名称" />
		</div>
		<div class="row flex start limit" :data-length="addressLimit">
			<label>地 点：</label>
			<input v-model="params.address" maxlength="30" type="text" placeholder="请输入比赛地点" />
		</div>
		<!-- <div class="row flex start">
			<label>时 间：</label>
			<span @click="$refs.pickdate.show()" class="flex center">开始时间</span>
			<div class="to flex center">至</div>
			<span @click="$refs.pickdate.show()" class="flex center">结束时间</span>
		</div>-->
		<div class="row flex start">
			<label>时 间：</label>
			<span @click="datePickType=0,$refs.pickdate.show()" :class="{'gray':!selectTime[0].date}" class="flex center">{{selectTime[0].date||'开始日期'}}</span>
			<div class="to flex center">-</div>
			<span @click="timePickType=0,$refs.picktime.show()" :class="{'gray':!selectTime[0].time}" class="flex center">{{selectTime[0].time||'开始时间'}}</span>
		</div>
		<div class="row flex start">
			<label></label>
			<span @click="datePickType=1,$refs.pickdate.show()" :class="{'gray':!selectTime[1].date}" class="flex center">{{selectTime[1].date||'结束日期'}}</span>
			<div class="to flex center">-</div>
			<span @click="timePickType=1,$refs.picktime.show()" :class="{'gray':!selectTime[1].time}" class="flex center">{{selectTime[1].time||'结束时间'}}</span>
		</div>
		<div class="row flex start">
			<label>说 明：</label>
			<div class="textarea flex start-v">
				<textarea v-model="params.remarks" maxlength="500" cols="30" rows="10" placeholder="请输入文字"></textarea>
				<p class="flex end limit">{{remarksLimit}}</p>
			</div>
		</div>
		<div class="row flex start">
			<label>级 别：</label>
			<span @click="$refs.pickrank.show()" :class="{'gray':params.level==undefined}" class="arrow flex">{{params.level!==undefined?gradeType[params.level].label:'请选择'}}</span>
		</div>

		<!-- 裁判席 -->
		<p class="title referee">裁判席</p>
		<div class="row flex start limit" :data-length="chiefRefereeNameLimit">
			<label>主 裁：</label>
			<input v-model="params.chiefRefereeName" maxlength="20" type="text" placeholder="请输入姓名" />
		</div>
		<div class="row flex start limit" :data-length="chiefRefereeNumberLimit">
			<label></label>
			<input v-model="params.chiefRefereeNumber" maxlength="20" type="number" placeholder="请输入学号" />
		</div>
		<div class="row flex start limit" :data-length="deputyRefereeNameLimit">
			<label>副 裁：</label>
			<input v-model="params.deputyRefereeName" maxlength="20" type="text" placeholder="请输入姓名" />
		</div>
		<div class="row flex start limit" :data-length="deputyRefereeNumberLimit">
			<label></label>
			<input v-model="params.deputyRefereeNumber" maxlength="20" type="number" placeholder="请输入学号" />
		</div>
		<div class="row flex start limit" :data-length="recorderNameLimit">
			<label>记 录：</label>
			<input v-model="params.recorderName" maxlength="20" type="text" placeholder="请输入姓名" />
		</div>
		<div class="row flex start limit" :data-length="recorderNumberLimit">
			<label></label>
			<input v-model="params.recorderNumber" maxlength="20" type="number" placeholder="请输入学号" />
		</div>

		<div class="footer">
			<button v-throttle @click="createRace" class="btn-full">完成创建</button>
		</div>

		<SelectDate ref="pickdate" @confirm="dateChange($event,datePickType)" />
		<SelectTime ref="picktime" @confirm="timeChange($event,timePickType)" />
		<SelectSingle ref="pickrank" title="请选择比赛级别" :dataList="gradeType" @confirm="e=>{params.level=e.value}" />
	</div>
</template>

<script>
import SelectDate from "@manage/components/picker/date.vue";
import SelectTime from "@manage/components/picker/time.vue";
import SelectSingle from "@manage/components/picker/selectSingle.vue";
export default {
	components: {
		SelectDate,
		SelectTime,
		SelectSingle,
	},
	data() {
		return {
			gradeType: [
				{
					label: "班级内部比赛",
					value: 0,
				},
				{
					label: "班级间比赛",
					value: 1,
				},
				{
					label: "校级比赛",
					value: 2,
				},
			],

			datePickType: 0,
			timePickType: 0,
			selectTime: [
				{
					date: undefined,
					time: undefined,
				},
				{
					date: undefined,
					time: undefined,
				},
			],
			params: {
				teamId: undefined,
				name: "",
				address: "",
				startTime: undefined,
				endTime: undefined,
				remarks: "",
				level: undefined,
				chiefRefereeNumber: "",
				chiefRefereeName: "",
				deputyRefereeNumber: "",
				deputyRefereeName: "",
				recorderNumber: "",
				recorderName: "",
			},
		};
	},

	computed: {
		nameLimit() {
			return this.params.name.length + "/20";
		},
		addressLimit() {
			return this.params.address.length + "/30";
		},
		remarksLimit() {
			return this.params.remarks.length + "/500";
		},
		chiefRefereeNameLimit(){
			return this.params.chiefRefereeName.length + "/20";
		},
		chiefRefereeNumberLimit(){
			return this.params.chiefRefereeNumber.length + "/20";
		},
		deputyRefereeNameLimit(){
			return this.params.deputyRefereeName.length + "/20";
		},
		deputyRefereeNumberLimit(){
			return this.params.deputyRefereeNumber.length + "/20";
		},
		recorderNameLimit(){
			return this.params.recorderName.length + "/20";
		},
		recorderNumberLimit(){
			return this.params.recorderNumber.length + "/20";
		}
	},
	watch:{
		"params.chiefRefereeNumber":{
			handler(){
				this.params.chiefRefereeNumber = this.params.chiefRefereeNumber.slice(0,20);
			},
		},
		"params.deputyRefereeNumber":{
			handler(){
				this.params.deputyRefereeNumber = this.params.deputyRefereeNumber.slice(0,20);
			},
		},
		"params.recorderNumber":{
			handler(){
				this.params.recorderNumber = this.params.recorderNumber.slice(0,20);
			},
		}
	},

	mounted() {
		this.params.teamId = this.$route.query.gradeId || '';
	},
	methods: {
		dateChange(value, type) {
			console.log(value, type);
			this.selectTime[type].date = value;
		},
		timeChange(value, type) {
			this.selectTime[type].time = value;
		},

		async createRace() {
			if (!this.checkForm()) return;
			try {
				let {success,message} = await this.$http.post("h5/match/add",this.params)
				if(!success) throw new Error(message);
				this.$message(message);
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.error("createRace", error?.message);
			}
		},

		checkForm() {
			let {
				name,
				address,
				remarks,
				level,
				chiefRefereeNumber,
				chiefRefereeName,
				deputyRefereeNumber,
				deputyRefereeName,
				recorderNumber,
				recorderName,
			} = this.params;
			let startTime = this.selectTime[0];
			let endTime = this.selectTime[1];
			if (
				!name ||
				!address ||
				level == undefined ||
				!chiefRefereeName ||
				!chiefRefereeNumber ||
				!deputyRefereeName ||
				!deputyRefereeNumber ||
				!recorderNumber ||
				!recorderName ||
				!startTime.date ||
				!startTime.time ||
				!endTime.date ||
				!endTime.time
			) {
				this.$message("请完善比赛信息");
				return false;
			} else {
				this.params.startTime = startTime.date + " " + startTime.time;
				this.params.endTime = endTime.date + " " + endTime.time;
				if (
					new Date(this.params.startTime) >
					new Date(this.params.endTime)
				) {
					this.$message("结束时间不得早于开始时间");
					return false;
				} else return true;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.create {
	padding: 0 17 / @rem 100 / @rem;
	p {
		&.title {
			font-size: 17 / @rem;
			font-weight: bold;
			letter-spacing: 1 / @rem;
			&::after {
				content: "";
				display: block;
				margin: 11 / @rem 0;
				width: 36 / @rem;
				height: 2 / @rem;
				background-color: #ffa216;
				border-radius: 2 / @rem;
			}
		}
		&.referee {
			padding-top: 20 / @rem;
		}
	}
	.row {
		padding-bottom: 10 / @rem;
		label {
			min-width: 50 / @rem;
			align-self: flex-start;
			line-height: 42 / @rem;
		}
		input,
		.textarea,
		> span {
			height: 42 / @rem;
			flex: 1;
			padding: 11 / @rem;
			font-size: 14 / @rem;
			letter-spacing: 1 / @rem;
			border: 1 / @rem solid rgba(31, 30, 29, 0.1);
			border-radius: 12 / @rem;
			&::placeholder {
				font-family: SourceHanSansCN-Regular;
				color: rgba(17, 17, 16, 0.3);
			}
		}
		input {
			height: 42 / @rem;
		}
		span {
			// color: rgba(17, 17, 16, 0.3);
			&.arrow {
				position: relative;
				&::after {
					content: "";
					display: block;
					width: 5 / @rem;
					height: 10 / @rem;
					position: absolute;
					right: 10 / @rem;
					background-image: url(~@img/icon/btn_xl.png);
					background-repeat: no-repeat;
					background-size: contain;
				}
			}
		}

		.textarea {
			height: 150 / @rem;
			overflow-y: auto;
			textarea {
				flex: 1;
				width: 100%;
				min-height: 100 / @rem;
				&::placeholder {
					font-family: SourceHanSansCN-Regular;
					color: rgba(17, 17, 16, 0.3);
				}
			}
			p {
				width: 100%;
				font-size: 10/@rem;
				padding-top: 5/@rem;
				color: rgba(17, 17, 16, 0.3);
			}
		}
		.to {
			padding: 0 11 / @rem;
			color: rgba(17, 17, 16, 0.3);
		}

		.img-list {
			flex-wrap: wrap;
			> img,
			.upload {
				width: 106 / @rem;
				height: 106 / @rem;
				object-fit: contain;
				border-radius: 7 / @rem;
				margin-right: 11 / @rem;
				margin-bottom: 11 / @rem;
				background-color: rgba(254, 198, 51, 0.2);
				&:nth-child(3n) {
					margin-right: 0;
				}
			}
			.upload {
				span {
					font-size: 13 / @rem;
					font-family: Source Han Sans CN-Medium;
					color: rgba(255, 162, 22, 1);
					padding-top: 8 / @rem;
				}
				img {
					width: 40 / @rem;
					height: 40 / @rem;
					object-fit: contain;
				}
			}
		}

		&.limit {
			position: relative;
			input {
				padding-right: 40 / @rem;
			}
			&::after {
				content: attr(data-length);
				position: absolute;
				right: 11 / @rem;
				color: rgba(17, 17, 16, 0.3);
				font-size: 10 / @rem;
			}
		}
	}

	.gray{
		color: rgba(17, 17, 16, 0.3);
	}
}
</style>
